<template>
    <div v-if="isLoggedIn" class="container page">
        <section v-if="displayPart==-1" class="card card-default">
            <div class="col-sm-8"><h5>{{awardTitle}} is Closed</h5></div>

        </section>

        <section v-if="displayPart==10" class="card card-default">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-8"><h5>{{awardTitle}}</h5></div>
                    <div class="col-sm-4">   
                    </div>
                </div>
            </div>
            <div class="card-body" >
                <div class="nomMessage">
                    <b-card no-body>
                        <b-tabs pills vertical lazy card no-nav-style nav-wrapper-class="col-12 col-md-4" content-class="col-12 col-md-8">
                            <b-tab>
                                <template v-slot:title>
                                    <div class="text-center"><b-img thumbnail fluid :src="require('../assets/image/ceosra.jpg')" alt=""></b-img></div>
                                    <div class="mb-1 text-center ceo">Anton Gildenhuys</div>
                                </template>
                                <b-card-text class="text-left">
                                    <p class="mb-3">Dear Sanlam Life &amp; Savings collegues.</p>

                                    <p>Recognising and rewarding our top achievers is one of my greatest pleasures as Chief Executive of Sanlam Life and Savings (SLS).</p>
                                    <p>I encourage you to participate in this flagship recognition programme which has become part of our culture, and which strongly contributes to making our people feel appreciated and empowered for their dedication and commitment to our shared vision and goals.</p>
                                    <p>SLS’ success depends as much on our financial results as the way we deliver on our strategic goals, which can be summarised as: holistic client engagement, vesting and amplifying acquired businesses, product innovation, a superior rewards programme and optimal and efficient use of technology.</p>
                                    <p>In this, our people are the differentiating factor: whether it’s collaboration across the business or innovation that delivers operational excellence, our people contribute their time, talent and hard work to help us grow and innovate so that we can offer clients the holistic ‘one Sanlam’ experience they deserve.</p>
                                    <p>You can submit a nomination for a deserving individual or team under any of the award categories below:</p>
                                    <ul>
                                        <li>Innovator</li>
                                        <li>Fusion (Collaboration)</li>
                                        <li>One Sanlam Experience</li>
                                        <li>Ubuholi “leadership”</li>
                                        <!--<li>CEO award</li>-->
                                    </ul>
                                    <p>As we move forward, let’s continue to make recognition a core part of who we are and what we do. Together, through the Power of One, we will build a business that not only achieves great things but does so by truly valuing the people who make it possible.</p>


                                    <p>Kind regards</p>
                                    <p>Anton Gildenhuys</p>
                                    <p>CEO: Sanlam Life &amp; Savings</p>
                                </b-card-text>
                            </b-tab>

                            <hr />
                            <div class="text-right mt-3 mb-3">
                                <div v-if="isAwardRunning">
                                    <a class="btn btn-primary" href="#" @click.prevent="showNomForm()" v-b-tooltip.hover.left title="Create a new Award nomination">New Award Nomination</a>
                                </div>
                                <div v-else class="alert alert-secondary" role="alert">Nominations are now closed</div>
                            </div>
                        </b-tabs>
                    </b-card>
                </div>
            </div>
        </section>


        <template v-if="displayPart==0">
            <div class="row mb-2">
                <div class="col-sm-8">
                    <h5>{{awardTitle}}</h5>
                    Select an Award below, then complete your nomination.
                </div>
                <div class="col-sm-4 text-right">
                    <a href="#" @click.prevent="displayPart=10" class="btn btn-secondary">Back</a>
                </div>
            </div>
            <!--
    { value: '', text: '--- Please select an option ---' },
    { value: 'Individual', text: 'Individual' },
    { value: 'Team', text: 'Team' },
    { value: 'Simple Innovative Solutions', text: 'Simple Innovative Solutions' },
    { value: 'Exceptional Service', text: 'Exceptional Service < 35' },
    { value: 'General employee', text: 'General employee (non-management)' },
        -->
            <section class="card mb-4 nomAwardCategory3">
                

                <b-tabs v-model="tabIndex" lazy card nav-class="selcatNav">
                    <b-tab v-if="false" title="SLS CEO Award" @click="awardCatSelected('SLS CEO Award')">
                        <!-- We can turn SLS CEO Award tab on and off. Also check below! -->
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="slsaward_ceo.jpg" class="w-100" /></div>

                            <h3>SLS CEO Award</h3>
                            <hr />
                            <b>Definition:</b><br />
                            <p><i>This category is the highest honor bestowed by the Sanlam Life & Savings CEO and is open to any individual or team who has gone above and beyond to make a lasting, extraordinary impact on the organization.</i></p>
                            <p>This most prestigious award recognizes an outstanding individual or team whose exceptional contributions have had a transformative impact on the organization i.e. financial and non-financial. This prestigious accolade is awarded to those who have consistently demonstrated excellence in their work, exceeded expectations, and played a key role in success of our business. The recipient of this award is someone whose dedication, innovation, leadership, and character have set them apart as a true role model within the organization.</p>
                            <p><b>Key Criteria for Nomination:</b></p>
                            <p><b>Exceptional Performance:</b> The nominee consistently delivers above and beyond expectations, driving the organization toward success through their hard work, dedication, and results.</p>
                            <p><b>Innovation & Impact:</b> The nominee has introduced innovative ideas, solutions, or processes that have had a significant and positive impact on the organization’s growth, efficiency, or culture.</p>
                            <p><b>Leadership & Inspiration:</b> Whether formal or informal, the nominee leads by example, inspiring colleagues with their passion, vision, and positive influence on the workplace.</p>
                            <p><b>Collaboration & Teamwork:</b> The nominee actively fosters collaboration and teamwork, contributing to the success of the team, department, or organization through a spirit of mutual respect and support.</p>
                            <p><b>Exemplary Values:</b> The nominee embodies the core values and purpose of the SLS strategy, consistently demonstrating integrity, ethical behavior, and a commitment to the company’s goals and culture.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="One Sanlam Experience Award" @click="awardCatSelected('One Sanlam Experience Award')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="slsaward_experience.jpg" class="w-100" /></div>
                            <h3>One Sanlam Experience Award</h3>
                            <hr />
                            <!--<b-form-group id="groupSelectValue" label-for="selectValue" label="Category:" description="">
    <b-form-radio-group v-model="fNomination.form.awardCat">
        <b-form-radio value="One Sanlam Experience Award: Emerging">Emerging</b-form-radio>
        <b-form-radio value="One Sanlam Experience Award: Established">Established</b-form-radio>-->
                            <!--<b-form-radio value="One Sanlam Experience Award: Seasoned">Seasoned</b-form-radio>-->
                            <!--</b-form-radio-group>
    </b-form-group>-->
                            <b>Definition:</b><br />
                            <!--<p><div v-if="fNomination.form.awardCat === 'One Sanlam Experience Award: Emerging'">
        <strong>Emerging Specialist:</strong> This individual shows a level of proactiveness in continuously developing their skills, knowledge, and expertise within a particular domain or specialty. They demonstrate a deep passion for their field and are quickly building a reputation for their growing expertise. While they may not yet have extensive experience, they show promise through their dedication to learning, and application of specialized knowledge. These individuals are actively contributing fresh perspectives, and beginning to influence their teams or industry with their potential.
    </div>
    <div v-else-if="fNomination.form.awardCat === 'One Sanlam Experience Award: Established'">
        <strong>Established Specialist:</strong> This individual is a professional who has reached a high level of proficiency and depth of knowledge in their chosen field. They have demonstrated a consistent ability to apply their expertise effectively over time and have made notable contributions to their specialty area. Established specialists are respected for their experience, their ability to solve complex problems, and their role as a go-to resource for advice and guidance within their domain. They often mentor others, shape best practices, and play a critical role in the success of their teams and the overall organization.
    </div></p>-->
                            <p><i>This category is open to those in client-facing roles across all Sanlam Life & Savings.</i></p>
                            <p></p>
                            <p>The One Sanlam Experience Award celebrates individuals, teams who have  a holistic service and  engagement  client mindset . Who have consistently gone above and beyond to build, strengthen, and sustain meaningful relationships. Our clients are real people who trust us to help them during moments that matter in their lives. We care and value this relationship, treating them with respect and empathy.  This award recognizes those who demonstrate exceptional care, dedication, and service, ensuring that clients’ needs are met with empathy, responsiveness. Who create effortless client experiences that feel seamless, flexible and intuitive as well as human and empathic.</p>
                            <p>This award exemplifies the values of trust, collaboration, and long-term partnership, making a lasting, positive impact on client satisfaction and loyalty.</p>
                            <p></p>
                            <p><strong>Key Criteria for Nomination:</strong></p>
                            <p></p>
                            <p><b>Relationship building:</b>  The nominee has demonstrated a commitment to developing strong, authentic, and lasting client relationships.</p>
                            <p><b>Customer-centric approach:</b> The nominee consistently puts the client’s needs first, listening to feedback and adjusting meet their evolving goals.</p>
                            <p><b>Exceptional communication:</b> The nominee maintains open, transparent, and proactive communication with clients, ensuring they feel valued and understood.</p>
                            <p><b>Problem-solving:</b> The nominee is known for offering creative solutions and handling client challenges with professionalism and care.</p>
                            <p><b>Client satisfaction & retention:</b> The nominee has contributed to the long-term success of our clients – building satisfaction, trust, and loyalty of clients, leading to high levels of retention and repeat business.</p>



                        </b-card-text>
                    </b-tab>

                    <b-tab title="Ubuholi Award" @click="awardCatSelected('Ubuholi Award')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="slsaward_ubuholi.jpg" class="w-100" /></div>
                            <h3>Ubuholi Award</h3>
                            <hr />
                            <b>Definition:</b><br />
                            <p><i>This category is open to leaders at all levels and functions who have made an impact through their ethical leadership and integrity.</i></p>
                            <p>Ubuholi is a Nguni word for leadership, this award honors individuals who exemplify the highest standards of ethical leadership, integrity, and accountability in their actions. This award recognizes leaders who inspire through their transparency, honesty, and unwavering commitment to doing what is right, both for their teams and the broader business. The recipient will have demonstrated exceptional leadership qualities, guiding others with strong moral principles and fostering a culture of trust, respect, and fairness.</p>
                            <p><b>Key Criteria for Nomination:</b></p>
                            <p><b>Ethical Leadership:</b> The nominee consistently leads with honesty, transparency, and fairness, making decisions that align with strong ethical principles and promotes integration.</p>
                            <p><b>Trustworthiness:</b> The nominee builds trust through their actions and words, demonstrating reliability and dependability in both their team(s) and professional relationships.</p>
                            <p><b>Influence & Inspiration:</b> The nominee inspires others to act with integrity, serving as a role model who motivates and empowers their team or organization to uphold high standards and living Sanlam values.</p>
                            <p><b>Accountability:</b> The nominee takes responsibility for their actions, upholding their commitments, and encouraging others to do the same in both successes and setbacks.</p>
                            <p><b>Commitment to Values:</b> The nominee consistently applies Sanlam core values, particularly when faced with difficult decisions or situations, reinforcing a culture of integrity in their organization.</p>
                        </b-card-text>
                    </b-tab>

                    <b-tab title="Innovation Award" @click="awardCatSelected('Innovation Award')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="slsaward_innovator.jpg" class="w-100" /></div>
                            <h3>Innovation Award</h3>
                            <hr />
                            <b>Definition:</b><br />
                            <p><i>This category is open to innovation across our value chain - marketing, client relationships, advice, product and client service.  We are also keen to hear about innovation in our support functions, and the work that they do.</i></p>
                            <p>The Innovation Award recognizes exceptional individuals and  teams who have demonstrated innovative, creative, forward-thinking strategies, solutions and remarkable problem-solving abilities.</p>
                            <p>This award celebrates innovation which significantly transformed our business, improved efficiency, or introduced new or improved solutions or processes with a lasting impact. Nominations should highlight unique solutions, game-changing concepts, or forward-thinking solutions that have set new standards, brought measurable improvements to teams or business operations.</p>
                            <p><b>Key Criteria for Nomination:</b></p>
                            <p><b>Solution oriented:</b> The nominee has introduced a fresh perspective or a completely new approach that challenges the conventional.</p>
                            <p><b>Impact:</b> The innovation has made a significant, measurable impact within the business unit, SLS cluster, Sanlam group or industry.</p>
                            <p><b>Scalability:</b> The solution has potential for broader application or expansion.</p>
                            <p><b>Sustainability:</b> The innovation demonstrates long-term viability and contributes positively to the people, business and environment.</p>
                            <p><b>Leadership & Vision:</b> The nominee has shown vision, resilience, and leadership in bringing the innovation to life.</p>
                        </b-card-text>
                    </b-tab>
                    
                    <b-tab title="Fusion Award" @click="awardCatSelected('Fusion Award')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="slsaward_fusion.jpg" class="w-100" /></div>
                            <h3>Fusion Award</h3>
                            <hr />
                            <b>Definition:</b><br />
                            <p><i>This category is open to teams or individuals who have shown exceptional collaboration in any area, including project teams, cross-functional groups, partnerships, or strategic alliances.</i></p>
                            <p>The core value for the Fusion award is collaboration!  this award recognizes individuals, teams across SLS business units who have demonstrated outstanding teamwork, cooperation, and partnership across departments, disciplines, or external stakeholders. This award honors those who break down silos, foster a collaborative environment, and work collectively toward shared goals. The recipient of this award will have demonstrated a commitment to collective success, achieved through effective communication, mutual respect, and a shared purpose</p>
                            <p><b>Key Criteria for Nomination:</b></p>
                            <p><b>Teamwork & Synergy:</b> The nomiee(s) has actively contributed to the success of a collaborative initiative, bringing together diverse perspectives to achieve exceptional outcomes.</p>
                            <p><b>Effective Communication</b> The nominee(s) excels in maintaining clear, open lines of communication, ensuring that all team members are aligned and informed.</p>
                            <p><b>Problem-Solving:</b> The nomnee(s) has worked collaboratively to overcome challenges or obstacles, showing flexibility and creative thinking in a team setting.</p>
                            <p><b>Cross-Departmental/Eternal Collaboration:</b> The nominee(s) has fostered collaboration across different departments, functions, or with external partners to achieve common goals.</p>
                            <p><b>Positive Impact:</b> The nominee(s) effort have led to significant, positive outcomes for the organization, team and project demonstrating the power of working together.</p>
                        </b-card-text>
                    </b-tab>

                </b-tabs>
            </section>

            <section class="card card-default mt-3" v-if="fNomination.form.awardCat !== null">
                <div class="card-header">
                    <h5>Nomination for: <b class="darkShade">{{ fNomination.form.awardCat }}</b></h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6"><strong>Nominee{{isNomSingleOnly ? "" : "s"}}:</strong></div>
                        <div class="col-sm-6 text-right"></div>
                    </div>
                    <div v-for="r in selectedNominees" :key="r._rowNum" class="row">
                        <template v-if="r.isEntireDivision">
                            <div class="col-1 text-right"><b-icon icon="collection" style="color:#9f34a0"></b-icon></div>
                            <div class="col" style="color:#9f34a0">Entire division: {{ r.division }}</div>
                        </template>
                        <template v-else>
                            <div class="col-1 text-right"><b-icon icon="person" style="color:#ccc"></b-icon></div>
                            <div class="col">{{ r.firstname + ' ' + r.surname }}</div>
                            <div class="col">{{ r.division }}</div>
                        </template>
                    </div>
                    <div v-if="selectedNominees.length===0" class="text-danger">Please select nominee{{isNomSingleOnly ? "" : "s"}}.</div>
                    <div class="mt-1">
                        <b-button type="button" pill @click="$bvModal.show('modalChooseNominees')" variant="primary" size="sm">{{selectedNominees.length===0 ? 'Select' : 'Update'}}  Nominee{{isNomSingleOnly ? "" : "s"}}</b-button>
                        <!--<a href="#" @click.prevent="$bvModal.show('modalChooseNominees')">Select Nominees</a>-->
                    </div>

                    <hr />
                    <b-form @submit.prevent="onSubmitAward" novalidate>
                        <!--
        <b-form-group id="groupAwardCat" label-for="selectAwardCat" label="Award Category:" :invalid-feedback="fNomination.errors.awardCat" description="">
            <b-form-select id="selectAwardCat" v-model="fNomination.form.awardCat" :options="awardCatList" value-field="value" text-field="text" :state="fNomination.state.awardCat" />
        </b-form-group>
           -->
                        <b-form-group id="groupMotivation" label-for="txtMotivation" label="Motivation:" :invalid-feedback="fNomination.errors.motivation" :description="1500-fNomination.form.motivation.length + ' characters remaining'">
                            <b-form-textarea id="txtMotivation" v-model="fNomination.form.motivation" :state="fNomination.state.motivation" placeholder="Provide a short motivation" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <b-form-group id="groupaction" label-for="txtaction" label="Actions Taken:" :invalid-feedback="fNomination.errors.action" :description="1500-fNomination.form.action.length + ' characters remaining'">
                            <b-form-textarea id="txtaction" v-model="fNomination.form.action" :state="fNomination.state.action" placeholder="Describe action taken" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <b-form-group id="groupimpact" label-for="txtImpact" label="Impact:" :invalid-feedback="fNomination.errors.impact" :description="1500-fNomination.form.impact.length + ' characters remaining'">
                            <b-form-textarea id="txtImpact" v-model="fNomination.form.impact" :state="fNomination.state.impact" placeholder="Impact thereof" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <hr />
                        <div class="row">
                            <div class="col-sm-6"><strong>Endorser for your nomination:</strong></div>
                            <div class="col-sm-6 text-right"></div>
                        </div>
                        <div v-for="r in selectedNominators" :key="r._rowNum" class="row">
                            <template v-if="r.isEntireDivision">
                                <div class="col-1 text-right"><b-icon icon="collection" style="color:#9f34a0"></b-icon></div>
                                <div class="col" style="color:#9f34a0">Entire division: {{ r.division }}</div>
                            </template>
                            <template v-else>
                                <div class="col-1 text-right"><b-icon icon="person" style="color:#ccc"></b-icon></div>
                                <div class="col">{{ r.firstname + ' ' + r.surname }}</div>
                                <div class="col">{{ r.division }}</div>
                            </template>
                        </div>
                        <div v-if="selectedNominators.length!==2" class="text-danger">Select an endorser to support your nomination.</div>
                        <div class="mt-1"><b-button type="button" pill @click="$bvModal.show('modalChooseNominators')" variant="primary" size="sm">{{selectedNominators.length===0 ? 'Select' : 'Update'}} Endorser</b-button></div>
                        <!--<div class="text-center"><b-button type="button" @click="$bvModal.show('modalChooseNominators')" variant="primary">Select Nominators</b-button></div>-->
                        <hr />

                        <div class="text-right"><b-button type="submit" variant="primary">Submit</b-button></div>
                    </b-form>
                </div>
            </section>
        </template>

        <section v-if="displayPart==1" class="card card-default">
            <div class="card-header">
                <h5>{{awardTitle}}</h5>
            </div>
            <div class="card-body">
                <b-alert variant="success" show>
                    <h4 class="alert-heading">{{fNomination.form.awardCat}} Nomination</h4>
                    <p>Successfully submitted the {{fNomination.form.awardCat}} Nomination.</p>
                    <p>Your reference for this nomination is: <b>{{awardId}}</b></p>
                </b-alert>

                <b-button type="button" pill @click="displayPart=10" variant="primary">Ok</b-button>

            </div>
        </section>



        <!--
    **************************************************************************************************************************************************
                                                                M O D A L S
    **************************************************************************************************************************************************
    -->
        <!-- Modal - Nominees -->
        <b-modal id="modalChooseNominees" :title="'NOMINEE' + (isNomSingleOnly ? '' : 'S')" hide-footer size="xl" no-close-on-backdrop>
            <member-select :title="'Select Nominee' + (isNomSingleOnly ? '' : 's') + ' for the ' + fNomination.form.awardCat"
                           :selectedTitle="isNomSingleOnly ? 'Selected nominee' : 'Selected nominees'"
                           :defaultCountryCode="memberClusterCode"
                           :defaultDivisionCode="memberDivisionCode"
                           :selectedMems="selectedNominees"
                           :isCountryFixed="true"
                           :isAllowWholeDivision="false"
                           :showContinue="false"
                           excludeDivisionCode=""
                           memberType="sanlam-life-and-savings"
                           :isSingle ="isNomSingleOnly"
                           class="mb-3" />
            <hr />
            <div class="text-right"><b-button type="submit" variant="primary" @click="$bvModal.hide('modalChooseNominees')">Done</b-button></div>
        </b-modal>

        <!-- Modal - Nominators -->
        <b-modal id="modalChooseNominators" title="NOMINATORS" hide-footer size="xl" no-close-on-backdrop>
            <member-select title="Select an endorser to support your nomination"
                           selectedTitle="Selected endorser to support your nomination"
                           :defaultCountryCode="memberClusterCode"
                           :defaultDivisionCode="memberDivisionCode"
                           :selectedMems="selectedNominators"
                           :isCountryFixed="true"
                           :isAllowWholeDivision="false"
                           :showContinue="false"
                           :isSingle="true"
                           memberType="sanlam-life-and-savings"
                           class="mb-3" />
            <hr />
            <div class="text-right"><b-button type="submit" variant="primary" @click="$bvModal.hide('modalChooseNominators')">Done</b-button></div>
        </b-modal>


    </div>

</template>

<script>
    // @ is an alias to /src
    //import HelloWorld from '@/components/HelloWorld.vue'
    import SitecodeImage from '@/components/SitecodeImage';
    import axios from 'axios'
    //import sjData from '@/sjUtilData'
    import MemberSelect from '@/components/MemberSelect';
    //import ContentDb from '@/components/ContentDb';



    export default {
        name: 'SanlamAward',
        components: { MemberSelect, SitecodeImage },//, ContentDb },
        data() {
            return {
                isAwardRunning: true, //when false, nominations are closed

                awardTitle: "Sanlam Life & Savings Cluster Awards",
                displayPart: 10, //Sanlam Life &amp; Savings CEO Award:   -1: Closed  10:Open
                fNomination: {
                    //form: { awardCat: 'SLS CEO Award', motivation: '', action: '', impact: '' } //Enable when SLS CEO Award is active.
                    form: { awardCat: 'One Sanlam Experience Award', motivation: '', action: '', impact: '' }
                },
                tabIndex: 0,

                selectedNominees: [],
                selectedNominators: [],

                roles: { ca: false, cc: false, idea: false, inv: false },

                reportTitle: '',
                currentIdeaRowNum: null,
                modalPart: 0,

                //awardCatList: [
                //    { value: '', text: '--- Please select an option ---' },
                //    { value: 'One Sanlam Experience Award: Emerging', text: 'One Sanlam Experience Award: Emerging' },
                //    { value: 'Innovation', text: 'Innovation' },
                //    { value: 'Santam Experience', text: 'Santam Experience' },
                //    { value: 'Collaboration', text: 'Collaboration' },
                //    { value: 'Everyday Hero', text: 'Everyday Hero' },
                //    { value: 'Rising Star', text: 'Rising Star' }
                //],

                awardId: 0

            }
        },
        computed: {
            isLoggedIn() {
                return this.$store.state.isLoggedIn && (this.memberClusterCode == 'sra' || this.memberClusterCode == 'ra' || this.memberClusterCode == 'sc' || this.memberClusterCode == 'srm') //Only SLS
            },
            countryList() {
                if (this.isCountryFixed) { //only show the default cluster.
                    return this.$store.state.countryList.filter(country => country.countryCode === this.defaultCountryCode);
                } else {
                    return [{ countryCode: null, country: '-- Please select a Cluster--', disabled: true }]
                        .concat(this.$store.state.countryList);
                }
            },
            memberClusterCode() {
                return this.$store.state.memberStore.member.clusterCode
            },
            memberDivisionCode() {
                return this.$store.state.memberStore.member.divisionCode
            },
            currentIdea() {
                if (this.currentIdeaRowNum === null) return null;
                return this.ideas[this.currentIdeaRowNum];
            },
            isNomSingleOnly() {
                return false;// !this.fNomination.form.awardCat.startsWith("Innovation Award");

                //return this.fNomination.form.awardCat == 'Leadership with Excellence'
                //    || this.fNomination.form.awardCat == 'Rising Star'
                //    || this.fNomination.form.awardCat == 'Everyday Hero';
            }


        },
        created() {
            //formSetState must be called on creation, to ensure all fields are setup
            this.formSetState(this.fNomination, true, true) //formObj, resetState, resetForm

            this.$store
                .dispatch('getDivisionList', {})
                .then(() => {

                })
                .catch((error) => {
                    this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occured: ' + JSON.stringify(error)));
                });


        },
        mounted() {

        },
        methods: {
            showNomForm() {
                this.formSetState(this.fNomination, true, true) //formObj, resetState, resetForm
                this.displayPart = 0;
                this.$nextTick(() => {
                    this.tabIndex = 0; //Select first tab
                    this.awardCatSelected('One Sanlam Experience Award');  //ensure got awardCat for first tab
                    //this.awardCatSelected('SLS CEO Award');  //ensure got awardCat for first tab

                });
            },

            msgBox(msg, title) {
                this.$bvModal.msgBoxOk(msg, { title: typeof title === 'undefined' ? 'Please note:' : title, centered: true })
            },

            //*** formStatusUpdate - used to display form errors.
            //Ensure this.form contains the list of fields.
            //Call  formStatusUpdate(true) to initialise/clear the form errors.
            //formObject is the object that contains the following objects:  .form, .formState, .formErrors
            formSetState(formObj, resetState, resetForm) {
                if (typeof resetState === 'undefined') resetState = false;
                if (typeof resetForm === 'undefined') resetForm = false;
                if (typeof formObj.init === 'undefined') formObj.init = { ...formObj.form }; //Initialise .formInit object to be a copy of .form object.
                if (typeof formObj.errors === 'undefined') this.$set(formObj, 'errors', {}); //use this.$set  to make errors object reactive
                if (typeof formObj.state === 'undefined') this.$set(formObj, 'state', {});   //use this.$set  to make state object reactive

                if (resetState || resetForm) {
                    if (resetForm) formObj.form = { ...formObj.init }; //copy .init to .form

                    formObj.errors = {}; //reset formErrors object
                    formObj.state = {};
                }

                //update formState
                var fields = Object.getOwnPropertyNames(formObj.form);
                for (let i = 0; i < fields.length; i++) {
                    let field = fields[i];
                    if (resetState) {
                        formObj.state[field] = null;
                    } else if (typeof formObj.errors[field] === 'undefined' || formObj.errors[field] === '') {
                        formObj.state[field] = true;
                    } else {
                        formObj.state[field] = false;
                    }
                }
            },


            awardCatSelected(awardCat) {
                this.fNomination.form.awardCat = awardCat;
                this.selectedNominees = [];
            },

            onSubmitAward() {
                try {



                    if (this.selectedNominees.length === 0) {
                        this.msgBox('Please select at least one nominee.', 'Nominees are required');
                        return;
                    }

                    if (this.isNomSingleOnly && this.selectedNominees.length !== 1) {
                        this.msgBox('Only a single nominee may be selected.', 'Single Nominees');
                        return;
                    }

                    let nominators = this.selectedNominators.filter(item => !item.isEntireDivision);
                    if (nominators.length == 0) {
                        this.msgBox('Please select an endorser.', 'An endorser is required');
                        return;
                    }

                    this.formSetState(this.fNomination, true);//formObj, resetState, resetForm

                    this.fNomination.form.nominees = this.selectedNominees.map(item => item.isEntireDivision ? 'div:' + item.entireDivisionCode : item.memberId);

                    var payload = { ...this.fNomination.form, awardType: "sanlam-life-and-savings" }

                    if (nominators.length !== 0) {
                        payload.endorserMemberId = nominators[0].memberId;
                    }

                    return axios
                        .post(
                            '/api/SanlamAward/newnomination',
                            payload
                        )
                        .then(({ data }) => {
                            console.log(data);

                            const er = data.errorMessage;
                            this.awardId = data.awardId;

                            if (data.awardId == 0) {
                                this.msgBox('An unexpected error occured: ' + er)
                            } else {
                                this.displayPart = 1;
                                //this.msgBox('Successfully submitted nomination');
                            }
                        })
                        .catch((error) => {
                            this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occured: ' + JSON.stringify(error.response.data)));
                            if (error.response.data.formErrors) {
                                this.fNomination.errors = error.response.data.formErrors;
                                this.formSetState(this.fNomination);
                            }
                        })
                        ;
                } catch (err) {
                    this.msgBox(err.message, 'An unexpected error occured submitting the nomination');
                }
            },

        }




    }
</script>
